var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.422 29.775 22.246 15.59l-3.834-6.65-4.342-7.53a.818.818 0 0 0-1.417 0L4.458 15.58 1.11 21.37a.818.818 0 0 0 .709 1.228l6.324.004a.82.82 0 0 0 .71-.408l3.286-5.686.503-.87a.817.817 0 0 1 1.418.001l3.41 5.917.632 1.094a.82.82 0 0 1-.711 1.227l-7.441-.005a.82.82 0 0 0-.71.409l-3.167 5.477a.818.818 0 0 0 .708 1.228l6.558.004 8.178.005L29.71 31a.818.818 0 0 0 .712-1.225z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/AUDIO.434f65dd634bfc4ae1ccd401941539ae.svg";
export { ForwardRef as ReactComponent };